import React from 'react';

import PageLayout from '../../components/PageLayout';
import ContentContainer from '../../components/ContentContainer';
import LetsWorkTogether from '../../components/LetsWorkTogether';
import TeamList from '../../components/TeamList';
import Row from '../../components/Row';

import Background from './images/header-about-bg.png';
import AboutUs from './images/img-about-us.jpg';

const aboutPage = () => (
  <PageLayout
    title="About us"
    header="About us"
    intro="We help startups in early stages to take off and support them along their project life cycle."
    visual={Background}
  >
    <Row>
      <ContentContainer>
        361 Studio is a transparent and collaborative lab built for the digital
        era. We create digital experiences and solutions for — and with —
        startups and businesses. As a design studio, we approach products and
        services from a user centric perspective. Our team size acommodates to
        each project, making sure we get our clients' needs covered . Our
        practice is focused on mobile and web applications, interfaces and
        handling technologies like IoT, Augmented Reality, Blockchain,
        Artificial Intelligence and Machine Learning.
      </ContentContainer>

      <img src={AboutUs} alt="" style={{ width: '100%' }} />

      <ContentContainer>
        Our team size acommodates to each project, making sure we get our
        clients' needs covered. Let’s team up!
      </ContentContainer>
      <ContentContainer>
        <TeamList />
      </ContentContainer>
    </Row>

    <LetsWorkTogether />
  </PageLayout>
);

export default aboutPage;
